import i18n from '@/plugins/i18n';

const metricsCSGraphs = () => ({
  areaCharts: [
    {
      width: '48%',
      title: i18n.global.t('dbm.load'),
      header: {
        title: i18n.global.t('dbm.load'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cassandra_load',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.database-size'),
      header: {
        title: i18n.global.t('dbm.database-size'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#db9dfb', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cassandra_total_db_size',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.mbPerMinute'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '100',
    },

    {
      width: '48%',
      title: i18n.global.t('dbm.ss-table-and-pending-hints'),
      header: {
        title: i18n.global.t('dbm.ss-table-and-pending-hints'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#db9dfb'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cassandra_sstable_count,meter_cassandra_pending_hints',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('latency'),
      header: {
        title: i18n.global.t('latency'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#db9dfb', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_cassandra_local_read_latency,meter_cassandra_local_write_latency,meter_cassandra_local_scan_latency',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.seconds'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.seconds'),
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '100',
    },

    {
      width: '48%',
      title: i18n.global.t('dbm.keyspace-count'),
      header: {
        title: i18n.global.t('dbm.keyspace-count'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#2f67ff', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_cassandra_keyspaces_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.prepared-statements'),
      header: {
        title: i18n.global.t('dbm.prepared-statements'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#2f67ff', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_cassandra_prepared_statements_count,meter_cassandra_prepared_statements_evicted,meter_cassandra_prepared_statements_executed,meter_cassandra_prepared_statements_ratio',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.task'),
      header: {
        title: i18n.global.t('dbm.task'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#2f67ff', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_cassandra_active_tasks,meter_cassandra_blocked_tasks,meter_cassandra_completed_tasks',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.local-read-scan-write'),
      header: {
        title: i18n.global.t('dbm.local-read-scan-write'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#db9dfb', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_cassandra_local_read_count,meter_cassandra_local_scan_count,meter_cassandra_local_write_count',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.request'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.request'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.cache'),
      header: {
        title: i18n.global.t('dbm.cache'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#db9dfb', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_cassandra_counters_cache_hit_rate,meter_cassandra_keys_cache_hit_rate',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      title: i18n.global.t('dbm.compaction'),
      header: {
        title: i18n.global.t('dbm.compaction'),
        titleIcon: '',
        content: [],
        toolbar: true,
      },
      chartColor: ['#abc0ff', '#1fb4ff', '#db9dfb', '#db9dfb', '#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_cassandra_compaction_in,meter_cassandra_compaction_out',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartArea',
      unit: '',
      axisLabels: {
        x: i18n.global.t('time'),
        y: 'MB',
      },
      labels: {
        xAxis: i18n.global.t('time'),
        yAxis: 'MB',
      },
      showLegendForSeries: true,
      aggregation: '/',
      aggregationNum: '1048576',
    },
  ],
});

export default metricsCSGraphs;
